<template>
  <div class="w-full font-proxima">
    <div class="overflow-x-auto shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm bg-white">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-red-50">
          <tr>
            <th v-for="header in HEADERS" :key="header" class="p-2 text-left align-middle text-sm font-bold border border-white text-blue-500 whitespace-nowrap">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="(row, index) in rows" :key="row.id ?? index" :class="index % 2 === 0 ? undefined : 'bg-gray-100'">
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.name }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.type }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.isActive ? 'Active' : 'Inactive' }}</td>
            <td class="px-3 py-2 text-sm text-black text-right whitespace-nowrap">{{ money(row.balanceAwardedUsd) }}</td>
            <td class="px-3 py-2 text-sm text-black text-right whitespace-nowrap">{{ money(row.balanceAvailableUsd) }}</td>
            <td class="px-3 py-2 text-sm text-black text-right whitespace-nowrap">{{ percent(row.balanceAvailablePercent) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mt-1 text-xs text-gray-500">
      Showing {{ rows.length.toLocaleString() }} of {{ (output?.count ?? rows.length).toLocaleString() }} funding sources
    </p>
  </div>
</template>
<script setup lang="ts">
interface FundingSourceRow {
  id?: string;
  name?: string;
  type?: string;
  isActive?: boolean;
  balanceAwardedUsd?: number;
  balanceAvailableUsd?: number;
  balanceAvailablePercent?: number;
}

const props = defineProps<{ part: { output?: { count?: number; fundingSources?: FundingSourceRow[] } } }>();

const HEADERS = ['Name', 'Type', 'Status', 'Awarded', 'Available', 'Available %'];

const output = computed(() => props.part.output);
const rows = computed<FundingSourceRow[]>(() => output.value?.fundingSources ?? []);

// Values arrive pre-converted to dollars (see list_funding_sources selectResult)
const money = (usd?: number) => (usd == null ? '' : formatNumberToMoney(usd));
const percent = (value?: number) => (value == null ? '' : `${Math.round(value)}%`);
</script>
